import React from 'react';
import { componentService } from 'js/services/component.service';

export const Games = React.lazy(() => import(/* webpackChunkName: "games" */ './Games'));

componentService.registerPageComponents({ responsivegames: Games });
